import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";
import { FaSearch, FaSyncAlt, FaFileExport, FaSave } from "react-icons/fa";
import CustomMonthPicker from "common/CustomMonthPicker";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchTimesheetHRApprovalRequest, resetTimesheetHRApprovals } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import Loader from "../../../../common/pageLoader";
import { Link } from "@mui/material";
import { urlEncryptData } from "helpers/crypto_helper";
import useButtonAccess from "components/Common/useButtonAccess";
import { useLocation, useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";

const getDaysInMonthFromString = (dateStr) => {
  // if (!dateStr) return "";
  // const [year, month, day] = dateStr.split("-");
  // return new Date(Number(year), Number(month), 0).getDate();
  if (!dateStr) return "";
  const [year, month] = dateStr.split("-").map(Number);

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  if (year === currentYear && month === currentMonth) {
    return today.getDate();
  }

  return new Date(year, month, 0).getDate();
};

const TimeSheetHRApproval = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);

  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    dropdownAutoList,
    hrApprovals,
    shiftLateApprovalEmployeeList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    hrApprovals: state.TimesheetTransactionApprovalReducer?.hrApprovals,

    loading: state.TimesheetTransactionApprovalReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.TimesheetTransactionApprovalReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
    success: state.TimesheetTransactionApprovalReducer?.success
  }));

  const { time_sheetpending, employee_absentlist, employee_leaveapproval } = hrApprovals;
  const [timesheetHRApprovalSearch, setTimesheetHRApprovalSearch] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);

  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const toggle1 = () => setDropdownOpen1((prev) => !prev);

  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const toggle2 = () => setDropdownOpen2((prev) => !prev);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
    dispatch(resetTimesheetHRApprovals());
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      month: (() => { const d = new Date(); d.setMonth(d.getMonth() - 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; })(),
      fromDate: "",
      toDate: "",
      category: [],
      department: [],
      designation: [],
      employee: [],
      noOfDays: "",
    },
    validationSchema: Yup.object({
      month: Yup.string().nullable().required("Month is required"),
      // fromDate: Yup.string().required("From Date is required"),
      // toDate: Yup.string().required("To Date is required"),
      noOfDays: Yup.string().required("Number of Days is required"),
      // category: Yup.array()
      //   .of(Yup.object().shape({
      //     label: Yup.string().required(),
      //     value: Yup.string().required(),
      //   }))
      //   .min(1, "Select at least one category"),
      // department: Yup.array()
      //   .of(Yup.object().shape({
      //     label: Yup.string().required(),
      //     value: Yup.string().required(),
      //   }))
      //   .min(1, "Select at least one department"),
      // designation: Yup.array()
      //   .of(Yup.object().shape({
      //     label: Yup.string().required(),
      //     value: Yup.string().required(),
      //   }))
      //   .min(1, "Select at least one designation"),
      // employeeCode: Yup.array()
      //   .of(Yup.object().shape({
      //     label: Yup.string().required(),
      //     value: Yup.string().required(),
      //   }))
      //   .min(1, "Select at least one employee code"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append(
        "category_id",
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "department_id",
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "designation_id",
        values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
      );
      formData.append("month", values.month);
      formData.append("from_date", '');
      formData.append("to_date", '');
      formData.append("emp_id", values.employee?.value || '0');


      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchTimesheetHRApprovalRequest(formData));
      setTimesheetHRApprovalSearch(true)
    },
    validateOnMount: true,
  });

  useEffect(() => {
    setTimesheetHRApprovalSearch(false)
    if (formik.values.month) {
      const days = getDaysInMonthFromString(formik.values.month);
      formik.setFieldValue("noOfDays", days);
      dispatch(resetTimesheetHRApprovals());
    }
  }, [formik.values.month]);

  const pendingApprovalColumns = [
    { Header: "SNo", Cell: ({ row }) => time_sheetpending.length - row.index, className: "serial-no", applyHeaderClass: true, },
    { Header: "Code", accessor: "emp_code" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Date", accessor: "timesheet_date" },
    { Header: "Category", accessor: "emp_category" },
    { Header: "Department", accessor: "department_name" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Reporting", accessor: "reporting" },
  ];

  const absentColumns = [
    { Header: "SNo", Cell: ({ row }) => employee_absentlist.length - row.index, className: "serial-no", applyHeaderClass: true, },
    { Header: "Code", accessor: "emp_code" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Date", accessor: "timesheet_date" },
    { Header: "Category", accessor: "emp_category" },
    { Header: "Department", accessor: "department_name" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Reporting", accessor: "reporting" },
  ];

  const markerColumns = [
    { Header: "SNo", Cell: ({ row }) => employee_leaveapproval.length - row.index, className: "serial-no", applyHeaderClass: true, },
    { Header: "Code", accessor: "emp_code" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "From", accessor: "from_date" },
    { Header: "To", accessor: "to_date" },
    { Header: "Category", accessor: "emp_category" },
    { Header: "Department", accessor: "department_name" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Reporting", accessor: "reporting" },
    // { Header: "Title", accessor: "title" },
  ];

  const handleGenerate = () => {
    const data = urlEncryptData(JSON.stringify(formik.values));
    const encoded = encodeURIComponent(data);
    history.push(`/time-hr-approval-generate?id=${encoded}`);
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Timesheet for Payroll" />

        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col md={3} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="category">Category</Label>
                    <CustomSelect
                      id="category"
                      name="category"
                      options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                      value={formik.values.category || null}
                      onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                      isMulti
                    />
                    {formik.touched.category && formik.errors.category && (
                      <div className="text-danger">{formik.errors.category}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="department">Department</Label>
                    <CustomSelect
                      id="department"
                      name="department"
                      options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                      value={formik.values.department || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                      isMulti
                    />
                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger">{formik.errors.department}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="designation">Designation</Label>
                    <CustomSelect
                      id="designation"
                      name="designation"
                      options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                      value={formik.values.designation || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                      isMulti
                    />
                    {formik.touched.designation && formik.errors.designation && (
                      <div className="text-danger">{formik.errors.designation}</div>
                    )}
                  </FormGroup>
                </Col>

                {/* Employee Selection */}
                <Col md={3} sm={12} className="mb-3">
                  <FormGroup>
                    <Label for="employee">Employee</Label>
                    <CustomSelect
                      id="employee"
                      name="employee"
                      options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                      value={formik.values.employee || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                    />
                    {formik.touched.employee && formik.errors.employee && (
                      <div className="text-danger">{formik.errors.employee}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Month <span className="text-danger">*</span></Label>
                    <CustomMonthPicker
                      name="month"
                      value={formik.values.month}
                      onChange={(date) => formik.setFieldValue("month", date)}
                      onBlur={formik.handleBlur}
                      disableFuture={true}
                      className={`form-control ${formik.touched.month && formik.errors.month ? "is-invalid" : ""}`}
                    />
                    {formik.touched.month && formik.errors.month && (
                      <div className="text-danger">{formik.errors.month}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>No of Days <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      name="noOfDays"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.noOfDays}
                      className={formik.errors.noOfDays && formik.touched.noOfDays ? "is-invalid" : ""}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" color="secondary" onClick={formik.handleReset} className="btn button-cancel me-2" >
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {/* {timesheetHRApprovalSearch &&
                    [employee_absentlist, time_sheetpending, employee_leaveapproval].every(
                      (item) => !item || item.length === 0
                    ) && (
                      <Button type="button" className="btn button-add" onClick={handleGenerate}>
                        <i className="fas fa-plus me-1" /> Generate
                      </Button>
                  )} */}
                  {canApprove &&
                    timesheetHRApprovalSearch &&
                    [employee_absentlist, time_sheetpending, employee_leaveapproval].every(
                      (item) => !item || item.length === 0
                    ) && (
                      <Button
                        type="button"
                        className="btn button-add"
                        onClick={handleGenerate}
                      >
                        <i className="fas fa-plus me-1" /> Generate
                      </Button>
                    )}
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        {/* <Card>
          <CardBody>
            <Row>
              <Col md={6} >
                <div className="mb-3">
                  <h5 className="text-info dark-blue mb-0">Pending Approval Details</h5></div>
                <TableContainer
                  columns={pendingApprovalColumns}
                  data={pendingApprovalData}
                  isGlobalFilter={true}
                  customPageSize={10}
                  tableClass="align-middle table-nowrap mb-0"
                  noDataMessage="No Records Found"
                />
              </Col>
              <Col md={6}>
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                  <h5 className="text-info dark-blue mb-0">
                    Absent Details</h5>
                  <Button className="btn btn-sm btn-primary d-flex align-items-center gap-1" ><FaFileExport /> Export</Button>
                </div>
                <TableContainer
                  columns={absentColumns}
                  data={absentData}
                  isGlobalFilter={true}
                  customPageSize={10}
                  tableClass="align-middle table-nowrap mb-0"
                />
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <h5 className="text-info dark-blue mb-0">Marker Pending Approval Details</h5></div>
                <TableContainer
                  columns={markerColumns}
                  data={markerData}
                  isGlobalFilter={true}
                  customPageSize={10}
                  tableClass="align-middle table-nowrap mb-0"
                  noDataMessage="No Records Found"
                />
              </Col>
            </Row>
          </CardBody>
        </Card> */}

        <Card>
          <CardBody>
            <Row>
              <Col>
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 card-main-title">
                  <h5 className="title mb-0">Pending Timesheet Approvals</h5>
                  {/* {time_sheetpending && time_sheetpending.length > 0 && (
                      <Button className="btn btn-sm btn-primary d-flex align-items-center gap-1" ><i className="fas fa-file-export me-1" /> Export</Button>
                  )} */}
                  {time_sheetpending && time_sheetpending.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down" className="me-2">
                      <DropdownToggle color="primary" className="btn button-export mt-0">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(time_sheetpending, authDetails?.unit_fullname, authDetails?.unit_address, "Pending Approval Details")} >
                          <i className="fas fa-file-excel me-2 text-success" />
                          Export to Excel
                        </DropdownItem>
                        <DropdownItem onClick={() => exportEmployeeToPDF(time_sheetpending, authDetails?.unit_fullname, authDetails?.unit_address, "Pending Approval Details", pendingApprovalColumns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" />
                          Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                </div>
                <TableContainer
                  columns={pendingApprovalColumns}
                  data={time_sheetpending && time_sheetpending.length > 0 ? time_sheetpending : []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  tableClass="align-middle table-nowrap mb-0"
                  noDataMessage="No Records Found"
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row>
              <Col >
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 card-main-title">
                  <h5 className="title mb-0">
                    Absent Details</h5>
                  {/* {employee_absentlist && employee_absentlist.length > 0 && (
                      <Button className="btn btn-sm btn-primary d-flex align-items-center gap-1" ><i className="fas fa-file-export me-1" /> Export</Button>
                  )} */}
                  {employee_absentlist && employee_absentlist.length > 0 && (
                    <Dropdown isOpen={dropdownOpen1} toggle={toggle1} direction="down" className="me-2">
                      <DropdownToggle color="primary" className="btn button-export mt-0">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employee_absentlist, authDetails?.unit_fullname, authDetails?.unit_address, "Absent Details")} >
                          <i className="fas fa-file-excel me-2 text-success" />
                          Export to Excel
                        </DropdownItem>
                        <DropdownItem onClick={() => exportEmployeeToPDF(employee_absentlist, authDetails?.unit_fullname, authDetails?.unit_address, "Absent Details", absentColumns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" />
                          Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                </div>
                <TableContainer
                  columns={absentColumns}
                  data={employee_absentlist && employee_absentlist.length > 0 ? employee_absentlist : []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  tableClass="align-middle table-nowrap mb-0"
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row>
              <Col>
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 card-main-title">
                  <h5 className="title mb-0">Marker Pending Approval Details</h5>
                  {/* {employee_leaveapproval && employee_leaveapproval.length > 0 && (
                      <Button className="btn btn-sm btn-primary d-flex align-items-center gap-1" ><i className="fas fa-file-export me-1" /> Export</Button>
                  )}                  */}
                  {employee_leaveapproval && employee_leaveapproval.length > 0 && (
                    <Dropdown isOpen={dropdownOpen2} toggle={toggle2} direction="down" className="me-2">
                      <DropdownToggle color="primary" className="btn button-export mt-0">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employee_leaveapproval, authDetails?.unit_fullname, authDetails?.unit_address, "Marker Pending Approval Details")} >
                          <i className="fas fa-file-excel me-2 text-success" />
                          Export to Excel
                        </DropdownItem>
                        <DropdownItem onClick={() => exportEmployeeToPDF(employee_leaveapproval, authDetails?.unit_fullname, authDetails?.unit_address, "Marker Pending Approval Details", markerColumns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" />
                          Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                </div>
                <TableContainer
                  columns={markerColumns}
                  data={employee_leaveapproval && employee_leaveapproval.length > 0 ? employee_leaveapproval : []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  tableClass="align-middle table-nowrap mb-0"
                  noDataMessage="No Records Found"
                />
              </Col>
            </Row>
          </CardBody>
        </Card>

      </Container>
    </div >
  );
};

export default TimeSheetHRApproval;
